module.exports = __webpack_public_path__ + "static/media/post_doc.270ba850.jpg";